import dayjs from 'dayjs'

const format = 'HH:mm:ss:SSS MM-DD-YYYY'

export const getFormattedDate = () => dayjs().format(format)
